import {Injectable} from '@angular/core';
import {NgbDatepickerI18n, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@brunata-angular/util';

@Injectable()
export class NgbDatepickerI18nImpl extends NgbDatepickerI18n {
    private monthNames: string[] = [];
    private shortMonthNames: string[] = [];
    private dayNames: string[] = [];

    constructor(private translateService: TranslateService) {
        super();
        for (let i = 0; i < 12; i++) {
            this.monthNames.push(
                this.translateService.translate(`MONTHS_${i}`, 'webbill', 'calendar'),
            );
            this.shortMonthNames.push(
                this.translateService.translate(`MONTHSSHORT_${i}`, 'webbill', 'calendar'),
            );
        }
        for (let i = 0; i < 7; i++) {
            this.dayNames.push(this.translateService.translate(`DAYS_${i}`, 'webbill', 'calendar'));
        }
    }

    override getWeekdayLabel(weekday: number): string {
        return this.dayNames[weekday - 1].substring(0, 3);
    }

    override getMonthShortName(month: number): string {
        return this.shortMonthNames[month - 1];
    }

    override getMonthFullName(month: number): string {
        return this.monthNames[month - 1];
    }

    override getDayAriaLabel(date: NgbDateStruct): string {
        return `${date.day}-${date.month}-${date.year}`;
    }
}
